import './render-bank-logo.scss';

import { type FC } from 'react';

import { BANKS_ICONS_NAMES, DictTypes } from '@/constants';
import { useAppSelector } from '@/store';

type TImgProps = {
  selectedBank?: string;
  src?: string;
};
const RenderBankLogo: FC<TImgProps> = ({ selectedBank, src }) => {
  const { dicts } = useAppSelector((state) => state.dict);

  const bank = dicts?.[DictTypes.Banks]?.content?.find(
    (item) => item.name === selectedBank
  );
  const bankIcon: string =
    src ||
    BANKS_ICONS_NAMES[selectedBank as keyof typeof BANKS_ICONS_NAMES]?.icon ||
    '';

  return (
    <div className="render-bank-logo">
      <img
        className="render-bank-logo__image"
        src={bank?.icon || bankIcon}
        alt="bank-logo"
      />
    </div>
  );
};

export default RenderBankLogo;
